// extracted by mini-css-extract-plugin
export var base = "_3v-0";
export var updateBanner = "_3v-1";